import styled from 'styled-components'

export const LandingPageHeadline = styled.h1`
    text-align: center;
    margin-top: 30px;
`

export const LandingPageLogo = styled.img`
    height: 200px;
    width: 100%;
    margin-bottom: 30px;
`



// WEBPACK FOOTER //
// ./src/components/StyledComponents/Pages/Landing.js